import legendaryGroupsJson from '../jsons/legendarygroups.json'
import { legendaryDescDefault } from '../replacements.js'

const legendaryGroups = legendaryGroupsJson.legendaryGroup;

const COLOR_RED = "#D44E3B"
const COLOR_GREEN = "#68AA33"

const alignmentConst = {
    'L' : 'Lawful',
    'C' : 'Chaotic',
    'G' : 'Good',
    'E' : 'Evil',
    'N' : 'Neutral',
    'U' : 'Unaligned',
    'A' : 'Any Alignment'
}

const allyConst = {
    'G' : 'ally',
    'E' : 'enemy',
    'A' : 'enemy',
    'N' : 'neutral',
    'U' : 'neutral'
}

const colors = {
    "enemy": COLOR_RED,
    "neutral": '#999999',
    "ally": COLOR_GREEN,
    "pet": COLOR_GREEN
}

const sizeConst = {
    'T': 'Tiny',
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'H': 'Huge',
    'G': 'Gargantuan',
}

const calcSize = (sizeArray) => {

    if(sizeArray) {
        let size = sizeArray.map((s) => sizeConst[s]).join(", ")
        return size
    }
        
    return "NO SIZE"
}

const calcAlignment = (alignmentArray) => {
    if(alignmentArray)
        return alignmentArray
            .map((a) => alignmentConst[a] || "") // Handle unmatched keys
            .join(" "); // Join matches into a single string
    return "--"
}

const calcSpeed = (speed) => {
    if(!speed) {
        return {'walk': 0}
    }

    if(speed && Object.entries(speed).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
            speed[key] = `${value.number} ${value.condition}`.trim();
        } else {
            speed[key] = value;
        }
    }))


    if(speed?.fly?.number) {
        speed.fly = speed.fly.number
    }

    if(speed?.canHover) {
        speed.hover = speed.canHover
    }

    return speed;
}

const calcActionTypes = (actionJson) => {
    if(actionJson) {
        actionJson.forEach(action => {
            action.desc = " "
            action.entries.forEach(entry => {
                if(typeof entry === 'string')
                    action.desc += entry + " "
                else if(typeof entry === 'object') {
                    if(entry.entries)
                        actionJson.push({name: entry.name, desc: " " + entry.entries.join(" ")})
                }
            })
           
        });
    }

    return actionJson;
}

const calcCreatureType = (type) => {
    if(typeof type === 'string') {
       return type
    } else if(typeof type.type === 'string') {
        return type.type
    } else {
        return type.type.choose.map((t) => capsFirstLetter(t)).join(" or ")
    }
}

// For immunities and resistances
const calcImmune = (defense, cKey) => {
    if (!defense) return "";

    const dString1 = defense
        .filter(entry => typeof entry === "string")
        .join(", ");

    let dString2 = defense
        .filter(entry => typeof entry === "object" && entry[cKey])
        .map(entry => `${entry[cKey].join(", ")} ${entry?.note}`)
        .join("; ");

    dString2 = dString2.replace('that is nonmagical', '(Non-Magical)')

    return `${dString1}${dString2 ? `${dString1 && ';' } ${dString2}` : ""}` 
};

const allyCheck = (alignmentArray) => {
    if(alignmentArray)
        alignmentArray.forEach(a => {
            if(a === "E" || a === "N" || a === "U" || a === "G") {
                return allyConst[a]
            }
        });
    return 'enemy'
}

function capsFirstLetter(word) {
    if (!word || word === '--')
        return '';

    return word.charAt(0).toUpperCase() + word.slice(1);
}

function mapSkills(skills) {
    if(skills) {
        let skillString = Object.entries(skills).map(([key, value]) => (
            capsFirstLetter(key) + value
        )).join(", ")
        return skillString
    }
    else 
        return ''
}

function calcSave(skill) {
    if(!skill && skill !== 0) return 0

    return Math.floor((skill-10)/2)
}

function addRechargeCount(objectsArr) {
    if(objectsArr) 
        return objectsArr.map(obj => {
            const match = obj.name.match(/\((\d+)\/[^)]+\)/); // Match (X/any text) pattern
            obj.rechargeCount = match ? parseInt(match[1]) * 10 : 0; // Set to null if no pattern is found
            return obj;
        });
    else 
        return null
}

const calcSenses = (senses, passive) => {
    let sensesString = ''
    if(senses) {
        sensesString = senses.join(", ")
    }

    if(passive)
        sensesString += `${sensesString ? ',' : ''} Passive Perception ${passive}`

    return sensesString
}

const calcCr = (monster) => {

    let cr = monster?.cr?.cr || monster.cr
    // if(monster?.cr?.lair)
    //     cr += "Lair: " + monster?.cr?.lair
    return cr
}

const calcAC = (monster) => {
    if(Array.isArray(monster?.ac)) {
        if(monster.ac[0]?.ac) {
            return monster.ac[0]?.ac
        } else if(typeof monster.ac[0] === 'number') {
            let ac = monster.ac[0];
            if(typeof monster.ac[1] === 'object') {
                ac = `${ac.toString()} (${monster.ac[1].ac.toString()} ${monster.ac[1].condition})`
            }
            
            return ac
        } else
            return monster?.ac[0]?.special
    }

    return 10;
}

const calcSpellCasting = (spellcasting) => {
    if(!spellcasting) {
        return []
    }

    return spellcasting.map((spellObj) => {
        let headerEntry = spellObj?.headerEntries?.join(" ");
        return {...spellObj, headerEntries: headerEntry}
    })

}

function getFirstValue(str) {
    if (typeof str !== "string") return "";
    return str.split(" ")[0];
}

// Implement the _copy logic
const findLairActions = (monster) => {
    // find specific monster with group name and source name
    let specificGroup = legendaryGroups.find(group => (group.name === monster?.legendaryGroup?.name && group.source === monster.source));
    
    // This creature is an abstraction of a parent group 
    if(specificGroup?._copy) {
        let templateGroup = {...legendaryGroups.find(group => (group.name === specificGroup?._copy?.name && group.source === specificGroup?._copy?.source))};
        
        if(templateGroup) {
            if(specificGroup._copy._mod.lairActions.mode === "prependArr") {
                templateGroup.lairActions = [...specificGroup._copy._mod.lairActions.items, ...templateGroup.lairActions]
            } else if(specificGroup._copy._mod.lairActions.mode === "appendArr") {
                templateGroup.lairActions = [...templateGroup.lairActions, ...specificGroup._copy._mod.lairActions.items]
            }

            return {
                lair_actions: templateGroup.lairActions || [],
                regional_effects: templateGroup.regionalEffects || []
            }       
        }
    }

    let extraActions = {
        lair_actions: specificGroup?.lairActions || [],
        regional_effects: specificGroup?.regionalEffects || []
    }

    return extraActions
}

const sortHp = (creature) => {
    let hp = {}

    let averageHp = creature?.hp?.average
    let specialHp = creature?.hp?.special

    if(averageHp) {
        hp = {
            "hit_points_default": averageHp,
            "hit_points_special": specialHp, // could be undefined
            "hit_points": averageHp,
            "hit_points_current": averageHp,
        }
    } else if(specialHp) {

        // if no average and only digits special
        if (/^\d+$/.test(String(specialHp))) {
            hp = {
                "hit_points_default": specialHp,
                "hit_points_special": undefined,
                "hit_points": specialHp,
                "hit_points_current": specialHp,
            }
        } else {
            // if no average and string special has more then just digits get first value before space i.e.
            // "special": "30 + 10 for each spell level above 4" -> "30"
            let hpString = getFirstValue(specialHp)

            if (/^\d+$/.test(String(hpString))) {
                hp = {
                    "hit_points_default": hpString,
                    "hit_points_special": specialHp, //"special": "40 + 10 for each spell level above 4th"
                    "hit_points": hpString,
                    "hit_points_current": hpString,
                } 
            } else {
                // this special only has no value, set everything to 10
                hp = {
                    "hit_points_default": 10,
                    "hit_points_special": specialHp, // Full string special
                    "hit_points": 10,
                    "hit_points_current": 10,
                } 
            }
        }
    } else {
        // No hp values at all
        hp = {
            "hit_points_default": 5,
            "hit_points_special": undefined,
            "hit_points": 5,
            "hit_points_current": 5,
        };
    }

    return hp
}

export const tools5eToDmBMapper = (monster, avatarUrl = null) => {
    let alignment = allyCheck(monster.alignment)
    const armor_class = calcAC(monster) 
    const armor_desc = Array.isArray(monster?.ac) && monster?.ac[0]?.from ? ("(" + (monster?.ac[0]?.from?.join("")) + ")") : "";
    const cr = calcCr(monster)

    const str = monster.str ?? 0;
    const dex = monster.dex ?? 0;
    const con = monster.con ?? 0;
    const int = monster.int ?? 0;
    const cha = monster.cha ?? 0;
    const wis = monster.wis ?? 0;

    const hpValues = sortHp(monster)

    let {lair_actions, regional_effects} = findLairActions(monster);

    return {
        "name": monster.name,
        "name_default": monster.name,
        "from": "t5",
        "creatureGuid": null,
        "avatarUrl": avatarUrl,
        "speed": calcSpeed(monster.speed),
        "armor_class": armor_class,
        "armor_desc": armor_desc,
        "creature_alignment": calcAlignment(monster.alignment),
        "alignment": alignment,
        "size": calcSize(monster.size),
        "type": "monster",
        "border": colors[alignment],
        "creature_type": calcCreatureType(monster?.type),
        "subtype": capsFirstLetter(monster.type?.tags?.join(",") || '--'),
        "hit_points_formula": monster?.hp?.formula,
        ...hpValues, // hit_points_default, hit_points_special, hit_points, hit_points_current
        "hit_points_temp": 0,
        "hit_points_override": 0,
        "hit_points_modifier": 0,
        "initiative": 0,
        "effects": [],
        'damage_vulnerabilities': monster?.vulnerable?.join(', ') || "",
        'damage_resistances': calcImmune(monster?.resist, "resist") || "",
        'damage_immunities': calcImmune(monster?.immune, "immune"),
        'condition_immunities': monster?.conditionImmune?.join(', ') || "",
        "skills": mapSkills(monster.skill),
        "senses": calcSenses(monster?.senses, monster?.passive),
        'languages': monster?.languages?.join(', '),
        "cr": cr,
        "challenge_rating": cr,
        "special_abilities": addRechargeCount(calcActionTypes(monster?.trait || null)),
        "spellcasting": calcSpellCasting(monster?.spellcasting),
        "actions": addRechargeCount(calcActionTypes(monster?.action) || null),
        "bonus_actions": addRechargeCount(calcActionTypes(monster?.bonus) || null),
        "reactions": addRechargeCount(calcActionTypes(monster?.reaction) || null),
        "legendary_actions_count": monster?.legendary?.length > 0 ? (monster.legendaryActions ? monster.legendaryActions * 10 : 30) : 0,
        "legendary_actions": addRechargeCount(calcActionTypes(monster?.legendary) || null),
        "legendary_desc": monster?.legendary?.length ? (monster?.legendaryHeader?.join(" ") || legendaryDescDefault(monster.name, monster.legendaryActionsLair)) : "",
        "lair_actions": lair_actions, 
        "regional_effects": regional_effects, 
        "inspiration": false,
        "hidden": true,
        "death_saves_failure_count": 0,
        "death_saves_success_count": 0,
        "environments": '',
        "strength": str,
        "dexterity": dex,
        "constitution": con,
        "intelligence": int,
        "charisma": cha,
        "wisdom": wis,
        "strength_save": monster.save?.str ?? calcSave(str),
        "dexterity_save":  monster.save?.dex ?? calcSave(dex),
        "constitution_save":  monster.save?.con ?? calcSave(con),
        "intelligence_save":  monster.save?.int ?? calcSave(int),
        "charisma_save":  monster.save?.cha ?? calcSave(cha),
        "wisdom_save":  monster.save?.wis ?? calcSave(wis),
        "dnd_b_player_id": null,
        "sourceShort": monster?.source,
        "page": monster?.page,

    }
};

export default tools5eToDmBMapper;